import { render, staticRenderFns } from "./payrollReport.vue?vue&type=template&id=6bb97823&scoped=true"
import script from "./payrollReport.vue?vue&type=script&lang=js"
export * from "./payrollReport.vue?vue&type=script&lang=js"
import style0 from "./payrollReport.vue?vue&type=style&index=0&id=6bb97823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb97823",
  null
  
)

export default component.exports